import { Navbar } from "@/components/Navbar";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { Hero } from "@/components/sections/Hero";
import { Problem } from "@/components/sections/Problem";
import { Difference } from "@/components/sections/Difference";
import { Products } from "@/components/sections/Products";
import { Niches } from "@/components/sections/Niches";
import { Journey } from "@/components/sections/Journey";
import { Implementation } from "@/components/sections/Implementation";
import { Pricing } from "@/components/sections/Pricing";
import { Faq } from "@/components/sections/Faq";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { Footer } from "@/components/sections/Footer";

export default function LandingPage() {
    return (
        <div className="bg-[#0A0A0F] text-[#F5F5F5] min-h-screen overflow-x-hidden">
            <Navbar />
            <main>
                <Hero />
                <Problem />
                <Difference />
                <Products />
                <Niches />
                <Journey />
                <Implementation />
                <Pricing />
                <Faq />
                <FinalCTA />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
